import React, { useState, useEffect } from 'react';
import { collection, getDocs } from "firebase/firestore";
import './Popup.css';
import franceMap from './france.jpg';
import { updateDocument, getDocument } from '../firestore';
import { doc,getDoc, setDoc, updateDoc, increment } from "firebase/firestore";
import { db, auth } from "../firebase";



const Popup = ({ onClose, onIncorrectAnswer, score, setScore, lives, setLives, useLives, gameOver }) => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [selectedChoice, setSelectedChoice] = useState([]);
  const [feedback, setFeedback] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(30);
  const [sequenceSlots, setSequenceSlots] = useState([]);
  const [draggedTerm, setDraggedTerm] = useState(null);
  const [answers, setAnswers] = useState({});
  const question_interval = 1000; 

  // Fetch questions from Firestore
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "questions 2.0"));
        const questionList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setQuestions(questionList);
      } catch (error) {
        console.error("Error fetching questions: ", error);
      }
    };
    fetchQuestions();
  }, []);

  const updateQuestionStats = async (category, isCorrect) => {
    const userId = auth.currentUser?.uid;
  
    if (!userId || !category) {
      console.error("Invalid userId or category:", { userId, category });
      return;
    }
  
    // Reference to the user's document in the 'questionstat' collection
    const userDocRef = doc(db, `questionstat/${userId}`);
    const categoryCollectionRef = collection(userDocRef, category); // Subcollection for the category
    const categoryDocRef = doc(categoryCollectionRef, "stats"); // Fixed document in subcollection  
    try {
      // Retrieve the current stats from Firestore
      const categoryDocSnap = await getDoc(categoryDocRef);
  
      let currentTotalQuestions = 0;
      let currentCorrectAnswers = 0;
      let currentwrongAnswers=0;
  
      if (categoryDocSnap.exists()) {
        const data = categoryDocSnap.data();
        currentTotalQuestions = data.totalQuestions || 0;
        currentCorrectAnswers = data.correctAnswers || 0;
        currentwrongAnswers =  data.wrongAnswers || 0;
      }
  
      // Prepare updated stats
      const updates = {
        totalQuestions: currentTotalQuestions + 1,
      };
  
      if (isCorrect) {
        updates.correctAnswers = currentCorrectAnswers + 1;
      }
      else{
        updates.wrongAnswers = currentwrongAnswers + 1;
      }
  
      // Update the document with the new values
      await setDoc(categoryDocRef, updates, { merge: true });
      console.log("Stats updated successfully:", updates);
    } catch (error) {
      console.error("Error updating stats:", error);
    }
  };
  
  
  useEffect(() => {
    if (showModal && timeRemaining > 0) {
      const timer = setInterval(() => {
        setTimeRemaining((prev) => prev - 1);
      }, 1000);
  
      return () => clearInterval(timer);
    } 
    else if (timeRemaining === 0) {
      handleSubmit(); // Automatically submit when time runs out
    }
  }, [showModal, timeRemaining]);
  

  useEffect(() => {
    if (!gameOver && lives > 0 && !showModal && questions.length > 0) {
      showRandomQuestion();
      const interval = setInterval(() => showRandomQuestion(), question_interval);
      return () => clearInterval(interval);
    }
    else if (gameOver || lives <= 0) {
      setShowModal(false); // Close the modal when the game is over
    }
  }, [gameOver, lives, showModal, questions]);

  useEffect(() => {
    if (feedback) {
      const timeoutId = setTimeout(() => handleClose(), 2000);
      return () => clearTimeout(timeoutId);
    }
  }, [feedback]);

  const showRandomQuestion = () => {
   
    if (questions.length === 0) return;
   
    const randomIndex = Math.floor(Math.random() * questions.length);
    const question = questions[randomIndex];
    

    function shuffleArray(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    }
    // Shuffle choices for the question
  if (question.choices) {
    question.choices = shuffleArray(question.choices);
  }
  // Shuffle terms and choices if available
  if (question.terms) {
    question.terms = shuffleArray(question.terms);
  }
  if (question.descriptions) {
    question.descriptions = shuffleArray(question.descriptions);
  }
    
    setCurrentQuestion(question);
    setShowModal(true);
    setTimeRemaining(30);
    setFeedback(null);
    setSelectedChoice([]);
    setIsCorrect(null);
    setAnswers({});
    setSequenceSlots(Array(question.steps?.length || 0).fill(null)); // Dynamically adjust slots
  };

  const handleChoiceSelect = (choice) => {
    setSelectedChoice((prev) => {
      if (currentQuestion.type === "Multiple Response") {
        return prev.includes(choice) ? prev.filter((c) => c !== choice) : [...prev, choice];
      } else {
        return [choice];
      }
    });
  };

  const handleSequenceStepClick = (step) => {
    setSequenceSlots((prevSlots) => {
      const newSlots = [...prevSlots];
      const firstEmptyIndex = newSlots.findIndex((slot) => slot === null);
      if (firstEmptyIndex !== -1) {
        newSlots[firstEmptyIndex] = step;
      }
      return newSlots;
    });
  };

  const handleDragStart = (term) => {
    setDraggedTerm(term);
  };

  const handleDrop = (description) => {
    if (draggedTerm) {
      setAnswers((prevAnswers) => ({
        ...prevAnswers,
        [draggedTerm]: description,
      }));
      setDraggedTerm(null);
    }
  };

  const handleSubmit = async () => {
    let correct = false;

    switch (currentQuestion.type) {
        case "drag-drop":
            correct = Object.keys(currentQuestion.correctAnswer).every(
                (term) => answers[term] === currentQuestion.correctAnswer[term]
            );
            break;
        case "Sequence":
          // Compare only filled slots with the correct answer
          const filledSlots = sequenceSlots.filter((slot) => slot !== null);
          correct =
          filledSlots.length === currentQuestion.correctAnswer.length &&
          JSON.stringify(filledSlots) === JSON.stringify(currentQuestion.correctAnswer);
          break;
        case "Fill in the Blank":
            const userAnswer = selectedChoice[0]?.trim().toLowerCase();
            correct = currentQuestion.correctAnswer.some(
                (answer) => answer.trim().toLowerCase() === userAnswer
            );
            break;
        case "Multiple Choice":
        case "True/False":
          correct = Array.isArray(currentQuestion.correctAnswer)
                ? JSON.stringify(selectedChoice.sort()) ===
                  JSON.stringify(currentQuestion.correctAnswer.sort())
                : selectedChoice[0] === currentQuestion.correctAnswer;
            break;
         case "Image Question": 
           correct = Array.isArray(currentQuestion.correctAnswer)
             ? selectedChoice.map(a => a.toLowerCase().trim()).sort().join(",") === 
               currentQuestion.correctAnswer.map(a => a.toLowerCase().trim()).sort().join(",")
             : selectedChoice[0]?.toLowerCase().trim() === currentQuestion.correctAnswer.toLowerCase().trim();
           break;
        case "Multiple Response":
          // Ensure `correctAnswer` is an array for consistent comparison
          const correctAnswersSet = new Set(
            currentQuestion.correctAnswer.map((answer) =>
                typeof answer === "string"
                    ? answer.trim().toLowerCase()
                    : String(answer).toLowerCase()
            )
        );

        const selectedAnswersSet = new Set(
            selectedChoice.map((choice) =>
                typeof choice === "string"
                    ? choice.trim().toLowerCase()
                    : String(choice).toLowerCase()
            )
        );

        // Check if selected answers match the correct ones exactly
        correct =
            selectedAnswersSet.size === correctAnswersSet.size &&
            [...correctAnswersSet].every((answer) =>
                selectedAnswersSet.has(answer)
            );
        break;
        default:
            correct = false;
    }
     // Update question stats in Firebase
    await updateQuestionStats(currentQuestion.category, correct);
    setFeedback(correct ? "Correct!" : "Incorrect");
    setScore((prevScore) => prevScore + (correct ? 50 : -50));
    handleGameplayDBUpdate(score, lives, correct);
    setIsCorrect(correct);
    setLives((prevLives) => correct ? prevLives : Math.max(prevLives - 1, 0));
    // if (!correct) {
    //   onIncorrectAnswer(); // Call the onIncorrectAnswer prop when answer is wrong
    // }
};


  const handleGameplayDBUpdate = async (currentScore, lives, is_correct) => {
    const queryParams = new URLSearchParams(window.location.search);
    const gameId = queryParams.get("id");
    const userId = auth.currentUser.uid;
    const subCollectionPath = `gameplay/${userId}/gameplays/`;
    const docData = await getDocument(subCollectionPath, gameId);
    const total_questions = docData.total_questions + 1;
    const correctAnswer = is_correct ? docData.questions_answered + 1 : docData.questions_answered;
    const gameplayData = {
      lives: lives,
      score: currentScore,
      total_questions: total_questions,
      questions_answered: correctAnswer,
      gameStarted: true
    };
    await updateDocument(subCollectionPath, gameId, gameplayData);
    await totalGameDataUpdate(currentScore, is_correct);
  };


  

  async function totalGameDataUpdate(score, is_correct) {
    const subCollectionPath = `gameplay`;
    const userId = auth.currentUser.uid;
    const docData = await getDocument(subCollectionPath, userId);
    const updatedScore = docData.score + score;
    const totalQuestions = docData.total_questions + 1;
    const questionsAnswered = is_correct ? docData.questions_answered + 1 : docData.questions_answered;

    const gameplayData = {
      score: updatedScore,
      total_questions: totalQuestions,
      questions_answered: questionsAnswered
    };
    await updateDocument(subCollectionPath, userId, gameplayData);
  }

  const handleClose = () => {
    setFeedback(null);
    setSelectedChoice([]);
    setIsCorrect(null);
    setShowModal(false);
    onClose();
  };

  const renderQuestion = () => {
    if (!currentQuestion) return null;

    switch (currentQuestion.type) {
      case "Multiple Choice":
      case "True/False":
      case "Multiple Response":
        return (
          <div className="choices">
            {currentQuestion.choices.map((choice, index) => (
              <label key={index} className="choice">
                <input
                  type={currentQuestion.type === "Multiple Response" ? "checkbox" : "radio"}
                  name="choice"
                  value={choice}
                  onChange={() => handleChoiceSelect(choice)}
                  checked={selectedChoice.includes(choice)}
                />
                {choice}
              </label>
            ))}
          </div>
        );
      case "Image Question":
        return (
          <>
            <img src={currentQuestion.questionImage || franceMap} alt="Question visual" className="question-image" />
            <div className="choices">
              {currentQuestion.choices.map((choice, index) => (
                <label key={index} className="choice">
                  <input
                    type="radio"
                    name="choice"
                    value={choice}
                    onChange={() => handleChoiceSelect(choice)}
                    checked={selectedChoice.includes(choice)}
                  />
                  {choice}
                </label>
              ))}
            </div>
          </>
        );
      case "Fill in the Blank":
        return (
          <input
            type="text"
            placeholder="Enter answer"
            className="popup-input"
            onChange={(e) => setSelectedChoice([e.target.value.toLowerCase()])}
          />
        );
      case "Sequence":
        return (
          <div className="sequence-container">
            <div className="sequence-steps">
              {currentQuestion.steps.map((step, index) => (
                <button
                  key={index}
                  onClick={() => handleSequenceStepClick(step)}
                  disabled={sequenceSlots.includes(step)}
                  className="sequence-step"
                >
                  {step}
                </button>
              ))}
            </div>
            <div className="sequence-drop-area">
              {sequenceSlots.map((slot, index) => (
                <div key={index} className={`sequence-slot ${slot ? 'filled' : ''}`}>
                  {slot || `Step ${index + 1}`}
                </div>
              ))}
            </div>
          </div>
        );
      case "drag-drop":
        return (
          <div className="drag-drop-container">
            <div className="terms">
              {currentQuestion.terms.map((term) => (
                <div
                  key={term}
                  draggable
                  onDragStart={() => handleDragStart(term)}
                  className="drag-item"
                >
                  {term}
                </div>
              ))}
            </div>
            <div className="descriptions">
              {currentQuestion.descriptions.map((description) => (
                <div
                  key={description}
                  onDrop={() => handleDrop(description)}
                  onDragOver={(e) => e.preventDefault()}
                  className="drop-zone"
                >
                  {description}
                  {Object.keys(answers).find((key) => answers[key] === description) && (
                    <div className="matched-term">
                      {Object.keys(answers).find((key) => answers[key] === description)}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  if (!showModal || !currentQuestion || gameOver || lives <= 0) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>Question</h2>
        <p className="question">{currentQuestion.question}</p>
        <div className="timer-bar" style={{ width: `${(timeRemaining / 30) * 100}%` }}></div>
        
        {renderQuestion()}
        {!feedback && (
          <button onClick={handleSubmit} className="submit-btn-pop">Submit</button>
        )}
        {feedback && (
          <div className={`feedback ${isCorrect ? 'feedback-correct' : 'feedback-incorrect'}`}>
            {feedback}
          </div>
        )}
        {feedback && (
          <button className="close-btn" onClick={handleClose}>
            Close
          </button>
        )}
      </div>
    </div>
  );
};

export default Popup;

